export default __webpack_public_path__ + "static/media/video1.c9716f4c.mp4";